/**
 * @Description:
 * @Author: fangzheng
 * @Date: 2020/8/3
 */
export default {
  organization: {
    organization: 'Organization',
    organizationDetails: 'Organization details',
    essentialInformation: 'Essential information',
    superiorOrganization: 'Superior organization',
    organizationType: 'Organization type',
    organizationNumber: 'Organization number',
    organizationName: 'Name of organization',
    tell: 'Tell',
    address: 'Address',
    remarks: 'Remarks',
    staff: 'Staff',
    employeeNumber: 'Employee number',
    employeeName: 'Employee name',
    mobileNumber: 'Mobile number',
    addAssociatedEmployee: 'Add associated employee',
    save: 'Save',
    state: 'State',
    remove: 'Remove',
    corporateInformation:'Corporate information',
    socialCreditCode:'Social Credit Code',
    legalPerson:'Legal person',
    businessLicense:'Duplicate of business license',
    originalCard :'Legal person id card (original)',
    counterCard :'Corporate identity card (counter)',
    company:'Company',
    department:'Department',
    addRoot:'Add root node',
    rootName:'Root node name',
    rootCode :'Root node code',
    relatedEmployee: 'Related employee',
    associated:'Associated',
    'code-0001':'Please enter organization number',
    'code-0002':'You can only enter numbers or letters',
    'code-0003':'Please enter Social Credit Code',
    'code-0004':'Add organization successfullly',
    'code-0005':'Edit organization successfullly',
    'code-0006':'Add root node successfullly',
    'code-0007':'Delete organization successfullly',
    'code-0008':'Already in the first place',
    'code-0009':'Already in the last place',
    'code-0010':'Please select an organization',
    'code-0011':'Select at least one item',
    'code-0012':'Add related employee successfully',
  }
};


// WEBPACK FOOTER //
// ./src/config/langs/en_US/organization.js